import {
  withCompInfo,
  withStateRefsValues,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations/siteAssets';
import { castFromInheritIfNeeded } from '@wix/editor-elements-common-utils';

import type { ITextParticlesDefinition } from '../documentManagement/TextParticles.definition';
import type { TextParticlesProps } from '../TextParticles.types';

export const props = withCompInfo<
  TextParticlesProps,
  ITextParticlesDefinition
>()(
  ['compData', 'directionWithOptInRtlSupport'],
  ({ compData, directionWithOptInRtlSupport }) => {
    const textDirection = castFromInheritIfNeeded(
      compData?.textDirection ?? 'inherit',
      directionWithOptInRtlSupport,
    );

    return {
      ...compData,
      textDirection,
    };
  },
);

export const stateRefs = withStateRefsValues([
  'editorType',
  'reducedMotion',
  'currentUrlWithQueryParams',
]);

export default createComponentMapperModel({ props, stateRefs });
